import { DTO } from '../DTO'

// 교재로 n차 학습지를 만들기 위해 옵션을 보내면 리턴받는 값

export class WorkbookDerivationResponse extends DTO implements res.WorkbookDerivation {
  problemList: res.WorkbookDerivation['problemList']
  baseProblemCount: res.WorkbookDerivation['baseProblemCount']
  conceptIdList: res.WorkbookDerivation['conceptIdList']
  conceptSize: res.WorkbookDerivation['conceptSize']
  problemSize: res.WorkbookDerivation['problemSize']
  worksheetLayout: res.WorkbookDerivation['worksheetLayout']

  constructor(data: res.WorkbookDerivation) {
    super()

    this.problemList = data.problemList
    this.baseProblemCount = data.baseProblemCount
    this.conceptIdList = data.conceptIdList
    this.conceptSize = data.conceptSize
    this.problemSize = data.problemSize
    this.worksheetLayout = data.worksheetLayout
  }
}
